import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import "../../styles/newbusiness.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Modal, ProgressBar } from "react-bootstrap";
import ScoreProgressBar from "../../components/NewBusiness/ScoreProgressBar";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import

const AITrailResults = () => {
    const { t } = useTranslation("BusinessDataPrivacyTrailResults");
    const navigate = useNavigate();
    const location = useLocation();
    const [caseStudies, setCaseStudies] = useState([]);
    const [result, setResult] = useState();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [submitted, setSubmitted] = useState(false);
    const [steps, setSteps] = useState({});
    const [text, setText] = useState("");
    const color = [
        "#002FA7",
        "#FDC93A",
        "#D2E23D",
        "#FD8AA8",
        "#66B49D",
        "#FFCEBF",
        "#CEE2F2",
        "#009045",
        "#484868",
        "#FFDC64",
    ];
    const paths = [
        "/free-trail/case-study",
        "/free-trail/course",
        "/free-trail/puzzle",
        "/free-trail/gamified-quiz",
        "/free-trail/facts",
        "/free-trail/what-did-you-learn",
        "/free-trail/whats-open",
        "/free-trail/apply-knowledge-to-real-life",
        "/free-trail/suggest-future-training-topics",
        "/free-trail/share-your-feedback",
    ];

    useEffect(() => {
        sessionStorage.clear();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async () => {
        if (!text) {
            toast.error(t("please_enter_feedback"));
            return;
        }
        try {
            toast.success(t("feedback_submitted_successfully"));
            setText("");
            setSubmitted(true);
        } catch (error) {
            // console.log(error);
        }
    };

    const handleNavigate = (path) => {
        navigate(path, {
            state: {
                step: true,
                trailId: location?.state?.trailId,
                name: location?.state?.name,
            },
        });
    };

    return (
        <>
            <Header />
            <main className="business_data_privacy_trail">
                <section>
                    <div className="trail_progress">
                        <div className="container">
                            <div className="row align-items-center g-4">
                                <div className="col-12 col-md-7 order-2 order-md-1">
                                    <span className="badge">
                                        {/* {t("hi")} {user?.username}, */}
                                    </span>
                                    <p>
                                        {t("congratulations")}{" "}
                                        {location?.state?.name} {t("trail")}
                                    </p>
                                    <h3>
                                        {location?.state?.name} -{" "}
                                        {t("interactive_learning")}
                                    </h3>
                                    <Link
                                        to="/trail/case-study"
                                        className="btn btn-primary d-inline-flex align-items-center gap-3"
                                        state={{
                                            trailId: location?.state?.trailId,
                                            name: location?.state?.name,
                                        }}
                                    >
                                        {t("tryitagain")}
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={22}
                                            height={14}
                                            viewBox="0 0 22 14"
                                            fill="none"
                                        >
                                            <path
                                                d="M1 6.99854H21L16 1"
                                                stroke="#fff"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M21 6.99854L16 13"
                                                stroke="#fff"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                    </Link>
                                    <div className="d-flex gap-3 gap-xxl-4 align-items-start mt-4 w-100 pt-0 pt-lg-5 score_progress_bar">
                                        <div className="overall_score_progress">
                                            <p className="pt-0">
                                                {t("youroverallscore")}
                                            </p>
                                            <ScoreProgressBar
                                                key={result?.average_score || 0}
                                                fontSize="36px"
                                                color="#002FA7"
                                                percentage={
                                                    result?.average_score
                                                        ? result.average_score
                                                        : 0
                                                }
                                                width={150}
                                                height={150}
                                                size={150}
                                                strokeWidth={15}
                                            />
                                        </div>
                                        <div className="w-100 ps-xxl-5">
                                            <h4 className="pt-0">
                                                {t("trailprogress")}
                                            </h4>
                                            <h5>
                                                {steps?.total_complete_step}/
                                                {steps?.total_step}{" "}
                                                {t("completed")}
                                            </h5>
                                            <ProgressBar
                                                now={
                                                    (steps?.total_complete_step /
                                                        steps?.total_step) *
                                                    100
                                                }
                                            />
                                            <h4 className="pt-0 my-4">
                                                {t("pointsearned")}:
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-5 d-flex justify-content-end order-1 order-md-2">
                                    <img
                                        src="/new-business/discussion-cuate.webp"
                                        className="pt-md-5"
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="data_privacy_overview py-5">
                    <div className="container">
                        <div className="d-md-flex justify-content-between align-items-center pb-4 pb-lg-5">
                            <h2>
                                {location.state.name} {t("trailoverview")}{" "}
                            </h2>
                        </div>
                        <div className="row g-4">
                            {caseStudies.map((caseStudy, index) => (
                                <div className="col-12" key={index}>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-12 col-md-7">
                                                    <div className="d-flex align-items-start align-content-md-center gap-4 flex-column flex-md-row">
                                                        <img
                                                            src={caseStudy.icon}
                                                            alt={
                                                                caseStudy.title
                                                            }
                                                        />
                                                        <div>
                                                            <h4>
                                                                {caseStudy.name}
                                                            </h4>
                                                            <p className="mb-2">
                                                                {
                                                                    caseStudy.description
                                                                }
                                                            </p>
                                                            <div className="d-flex align-items-center gap-3">
                                                                <p className="mb-0 text_light_200 fs-14 fw-600">
                                                                    {t(
                                                                        "pointsearned"
                                                                    )}{" "}
                                                                    :
                                                                </p>
                                                                <div className="business_data_privacy_trail">
                                                                    {caseStudy.title !==
                                                                        "Puzzle" && (
                                                                        <button className="award_btn fw-700 border-0 d-flex align-items-center gap-2">
                                                                            <img
                                                                                src="/new-business/award-icons.webp"
                                                                                width={
                                                                                    24
                                                                                }
                                                                                alt=""
                                                                            />
                                                                            {
                                                                                result
                                                                                    ?.steps[
                                                                                    index
                                                                                ]
                                                                                    ?.points_earned
                                                                            }
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-5 d-md-flex justify-content-md-end">
                                                    <div className="d-flex justify-content-between justify-content-md-end align-items-center gap-5 mt-4 mt-md-0">
                                                        {result?.steps?.length >
                                                            0 && (
                                                            <ScoreProgressBar
                                                                key={index}
                                                                fontSize="22px"
                                                                color={
                                                                    color[index]
                                                                }
                                                                percentage={
                                                                    result
                                                                        ?.steps[
                                                                        index
                                                                    ]?.score
                                                                }
                                                                width={100}
                                                                height={100}
                                                                size={150}
                                                                strokeWidth={15}
                                                            />
                                                        )}
                                                        <button
                                                            className="btn btn-primary bg-secondary fw-600"
                                                            onClick={() =>
                                                                handleNavigate(
                                                                    paths[index]
                                                                )
                                                            }
                                                        >
                                                            {t("replay")}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <Modal
                    centered
                    size="md"
                    className="feedback_modal"
                    show={show}
                    onHide={handleClose}
                >
                    <Modal.Header
                        className="border-0 pb-0 adjust-modal"
                        closeButton
                    />
                    <Modal.Body className="pt-0">
                        {!submitted ? (
                            <div className="feedback-step-1">
                                <h3>{t("feedback_prompt")}</h3>
                                <h6> {t("write_comment")}</h6>
                                <textarea
                                    className="form-control pt-3 bg-secondary fw-400"
                                    rows={6}
                                    placeholder={t("feedback_placeholder")}
                                    id="floatingTextarea2"
                                    value={text}
                                    onChange={(e) => setText(e.target.value)}
                                />
                            </div>
                        ) : (
                            <div className="feedback-step-2">
                                <div className="text-center">
                                    <img
                                        className="mx-auto d-flex"
                                        src="/new-business/feedback.webp"
                                        alt=""
                                    />
                                    <h4> {t("thankyouforyourfeedback")}</h4>
                                    <h5>{t("feedback_promptdes")}</h5>
                                </div>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer className="border-0">
                        {!submitted ? (
                            <Button variant="primary" onClick={handleSubmit}>
                                {t("submitfeedback")}
                            </Button>
                        ) : (
                            ""
                        )}
                    </Modal.Footer>
                </Modal>
            </main>
            <Footer />
        </>
    );
};

export default AITrailResults;
